export class RegisteredOrganization {
    constructor(data) {
        this.organizationId = data.organizationId;
        this.hccisId = data.hccisId;
        this.parentOrganizationId = data.parentOrganizationId;
        this.name = data.name;
        this.parentOrganizationName = data.parentOrganizationName;
        this.organizationTypeDesc = data.organizationTypeDesc;
        this.status = data.status;
        this.createDate = data.createDate;
        this.createContactName = data.createContactName;
        this.approveDate = data.approveDate;
        this.approvedContactName = data.approvedContactName;
        this.key = data.organizationId + '-' + data.parentOrganizationId;
        this.isRoot = data.organizationId == data.parentOrganizationId;
    }

}